/* eslint-disable */
// /src/services/eduPublicService.js
// 사용자용(읽기 전용) 교육자료 서비스 — 공지와 동일 포맷
import { db } from "./firebase";
import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    orderBy,
    limit as qlimit,
} from "firebase/firestore";

const COL = collection(db, "edu_contents");

/** 목록 (최신순) */
export async function listEduPublic({ limit = 100 } = {}) {
    const qy = query(COL, orderBy("publishedAt", "desc"), qlimit(limit));
    const snap = await getDocs(qy);
    const rows = [];
    snap.forEach((s) => {
        const v = s.data() || {};
        rows.push({
            id: s.id,
            title: v.title || "",
            snippet: v.snippet || "",
            imageUrl: v.imageUrl || "",
            videoUrl: v.videoUrl || "", // 🔹 영상 URL 함께 내려줌
            publishedAt: v.publishedAt?.toDate
                ? v.publishedAt.toDate()
                : v.publishedAt
                    ? new Date(v.publishedAt)
                    : null,
        });
    });
    return rows;
}

/** 단건 상세 */
export async function getEduPublic(id) {
    if (!id) return null;
    const ss = await getDoc(doc(COL, id));
    if (!ss.exists()) return null;
    const v = ss.data() || {};
    return {
        id: ss.id,
        title: v.title || "",
        bodyHtml: v.bodyHtml || "",
        imageUrl: v.imageUrl || "",
        videoUrl: v.videoUrl || "", // 🔹 상세에서도 영상 URL 포함
        snippet: v.snippet || "",
        publishedAt: v.publishedAt?.toDate
            ? v.publishedAt.toDate()
            : v.publishedAt
                ? new Date(v.publishedAt)
                : null,
        author: v.author || "",
    };
}
